export type ClipboardFieldType = 'text' | 'password' | 'link';

export enum TooltipType {
  COPY,
  OPEN_LINK,
  SHOW,
  HIDE,
}

export const buttonTooltipText: Record<TooltipType, string> = {
  [TooltipType.COPY]: $localize`Copy to clipboard`,
  [TooltipType.OPEN_LINK]: $localize`Open link`,
  [TooltipType.SHOW]: $localize`Show`,
  [TooltipType.HIDE]: $localize`Hide`,
};

export const PASSWORD_MASK = '•••••••••••••';
